exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}



//////////////////
// WEBPACK FOOTER
// ../~/browserify-aes/modes/ecb.js
// module id = ../node_modules/browserify-aes/modes/ecb.js
// module chunks = 0